"use strict";

exports.__esModule = true;
exports.StaticConfigurations = void 0;
var StaticConfigurations = exports.StaticConfigurations = [{
  plant: "demo",
  mappings: [{
    type: "MAXIMO",
    permission: "VIEW_MAXIMO",
    link: "/api/v1/ticketing/ticket/{id}",
    text: {
      LINK: "Link to Maximo",
      LINKING: "Linking to Maximo",
      LINKED: "Linked to Maximo",
      FAILED: "Link to Maximo"
    },
    isLinking: false,
    editableFields: ["title", "description"],
    allowEditWhen: ["LINK", "FAILED"]
  }]
}, {
  plant: "gebangor",
  mappings: [{
    type: "MAXIMO",
    permission: "VIEW_MAXIMO",
    link: "/api/v1/ticketing/ticket/{id}",
    text: {
      LINK: "Link to Maximo",
      LINKING: "Linking to Maximo",
      LINKED: "Linked to Maximo",
      FAILED: "Link to Maximo"
    },
    isLinking: false,
    editableFields: [],
    allowEditWhen: ["LINK", "FAILED"]
  }]
}, {
  plant: "test",
  mappings: [{
    type: "MAXIMO",
    permission: "VIEW_MAXIMO",
    link: "/api/v1/ticketing/ticket/{id}",
    text: {
      LINK: "Link to Maximo",
      LINKING: "Linking to Maximo",
      LINKED: "Linked to Maximo",
      FAILED: "Link to Maximo"
    },
    isLinking: false,
    editableFields: ["title", "description"],
    allowEditWhen: ["LINK", "FAILED"]
  }]
}];